<template>
  <main class="c-home main-contain" id="pg-business-funding">
    <section id="home-banner" class="parallax-background" data-paroller-factor="-0.09" data-paroller-factor-sm="-0.09" data-paroller-factor-xs="-0.09" :style="{ background: 'url('+ banner +') no-repeat center top'}">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="banner_description">
              <h1 class="white-c-1">Frequently <br/>Asked <br/>Questions</h1>
              <p class="white-c-1 font-regular">Review our list of FAQs below to answer any questions you may have.</p>
              <a href="#FaqMain" class="banner_scroll" >Scroll down to explore</a>
            </div>
          </div>
        </div>
      </div>
    </section>


    <section id="FaqMain">
      <div class="container">
        <div class="row">
          <div class="col-md-12 matchHeight">
              <div class="padd-tb85">
                <h1 class="font-bold  mar-no blue-c-3">FAQs</h1>

                <div id="FaqWrap">
                  <div id="accordion">

                      <h4 class="accordion-toggle"><span>How do I qualify? You qualify if…</span></h4>
                      <div class="accordion-content">
                      <ul>
                      <li>You own a business that already accepts credit cards (VISA, MASTERCARD, AMEX, DINER’S CLUB) as a form of payment.</li>
                      <li>Your business processes a minimum of $1,500 dollars a month in credit card sales.</li>
                      <li>You can provide recent credit card statements and bank statements (3 months if business is not seasonal and 12 months if business is seasonal).</li>
                      <li>You have been in business at least 1 year.</li>
                      </ul>
                      </div>

                     
                      <h4 class="accordion-toggle"><span>How easy is it to get approved by Dan Advance Funding?</span></h4>
                      <div class="accordion-content">
                      <ul>
                      <li>It is a lot easier and faster than a typical bank loan.</li>
                      <li>We understand the reality and the hardship of owning and operating a small to medium size business. The majority of our Funding Specialists have also owned and operated their own small to medium size businesses and understand how quickly you need capital, so our efforts to get you business funding is a top priority. Just as long as you own a business for at least 1 year and already accept credit card payments, you have made the process that much easier!</li>
                      </ul>
                      </div>

                      
                      <h4 class="accordion-toggle"><span>How can I speed up my cash advance approval?</span></h4>
                      <div class="accordion-content">Please make sure to immediately submit any information you might have omitted from the 1-page application and quickly email your Visa/MasterCard processing statements and bank statements to your Funding Specialist. Also, provide all documentation explaining any items that may create a questionable credit report and email it to info@danadvance.com.</div>
                      </li>

                      
                      <h4 class="accordion-toggle"><span>How do I get started?</span></h4>
                      <div class="accordion-content">Call Toll-Free today at 1-877-227-4060 and a Funding Specialist will walk you through the application process and help to answer all your questions.</div>
                      

                      <h4 class="accordion-toggle"><span>How does the program work?</span></h4>
                      <div class="accordion-content">
                      <ul>
                      <li>You can be advanced as little as $1,500 up to $1,000,000 based on your current credit card sales receipts.</li>
                      <li>A small agreed upon percentage is then deducted from your ongoing/future Visa and MasterCard receipts for payback.</li>
                      <li>There are no fixed payments and there is no fixed term time frame.</li>
                      </ul>
                      </div>
                      

                      <h4 class="accordion-toggle"><span>How much will unsecured cash advance cost?</span></h4>
                      <div class="accordion-content">
                      <ul>
                      <li>Pricing is based on the size of the cash advance, the estimated time of distribution, and various other integral details of the cash advance program.</li>
                      <li>This is explained at length in the Cash Advance Approval sheet</li>
                      </ul>
                      </div>
                      

                      <h4 class="accordion-toggle"><span>Will bad credit affect my unsecured cash advance request?</span></h4>
                      <div class="accordion-content">
                      <ul>
                      <li>It is not necessary for you to have good credit in order to receive an unsecured cash advance.</li>
                      <li>A poor credit rating, including delinquencies, will not normally influence an unsecured cash advance.</li>
                      </ul>
                      </div>
                      

                      <h4 class="accordion-toggle"><span>How fast can I get an unsecured cash advance?</span></h4>
                      <div class="accordion-content">In as fast as 72 hours! However, if relevant documents are missing or are difficult to obtain, the process can take as long as two weeks or more</div>
                      

                      <h4 class="accordion-toggle"><span>How much of an unsecured cash advance can I receive?</span></h4>
                      <div class="accordion-content">$1,500 up to $1,000,000</div>
                      

                      <h4 class="accordion-toggle"><span>How will I pay back the unsecured cash advance?</span></h4>
                      <div class="accordion-content">
                      <ul>
                      <li>On a formula calculated based on your cash flow projections.</li>
                      <li>We partner with you to determine your optimal payment</li>
                      </ul>
                      </div>
                      

                      <h4 class="accordion-toggle"><span>Is this a loan?</span></h4>
                      <div class="accordion-content">
                      <ul>
                      <li>No. This is not a loan.</li>
                      <li>It is a purchase of future credit card receivables, similar to a cash advance. However, it works in much the same way as a business loan would, only there is no fixed repayment schedule.</li>
                      </ul>
                      </div>
                      

                      <h4 class="accordion-toggle"><span>When I have repaid my first cash advance, how easy is it to apply again?</span></h4>
                      <div class="accordion-content">If you have experienced no change in financial status you will be approved automatically.</div>
                      

                      <h4 class="accordion-toggle"><span>How complicated is the paperwork?</span></h4>
                      <div class="accordion-content">
                      <ul>
                      <li>The paperwork that you will need to fill out is quite simple and takes no more than ten or fifteen minutes to complete.</li>
                      <li>We have Funding Specialists on hand in our call center to help you through the entire process</li>
                      </ul>
                      </div>
                      

                      <h4 class="accordion-toggle"><span>I am already with another financing company providing similar financing. Does that mean I will get approved by Dan Advance Funding?</span></h4>
                      <div class="accordion-content">
                      <ul>
                      <li>Our credit underwriting standard is slightly higher than that of similar companies; however, approximately 95% of our competitors’ customers who applied for our funding have been accepted.</li>
                      <li>The only sure way to find out is by submitting an application.</li>
                      </ul>
                      </div>
                      

                      <h4 class="accordion-toggle"><span>Can I receive financing from Dan Advance while the financing from another company is still outstanding?</span></h4>
                      <div class="accordion-content">
                      <ul>
                      <li>Yes, but we must pay off any outstanding cash advances out of our first advance to you. (You receive all remaining proceeds).</li>
                      <li>Depending on the particular finance company involved, there may be an exception to this policy, but most other credit card receivable companies will have to be paid off out of the first advance.</li>
                      </ul>
                      </div>
                      

                      <h4 class="accordion-toggle"><span>I have high enough overall sales, but my VISA/MC volume is very low. Is there any way I could receive funding?</span></h4>
                      <div class="accordion-content">Yes. The minimum requirement for qualification of the unsecured cash advance program is $1,500 of your monthly VISA/MC transactions. We custom tailor our products to suit our customers’ needs all the time. Just call and ask!</div>
                      

                      <h4 class="accordion-toggle"><span>Can the unsecured cash advance be renewed?</span></h4>
                      <div class="accordion-content">When the advance balance is down to approximately 20% of the original balance, the borrower can request for more money. As a matter of fact, most of our customers opt to do just that. The owner of the business can request a renewal by phone, fax, or e-mail. Renewals are usually funded in less than 24 hours of being requested.</div>
                      

                      <h4 class="accordion-toggle"><span>Do I have to switch my current credit card processor?</span></h4>
                      <div class="accordion-content">Our affiliated credit card processing companies will meet or beat your current credit card processing cost structure. The bottom line is that you’re not going to lose money for having to switch. (Most likely, you will be saving money by switching)</div>
                      

                      <h4 class="accordion-toggle"><span>Do I have to get a new credit card terminal?</span></h4>
                      <div class="accordion-content">Not usually. All you have to do is re-program your terminal, which takes only 10 minutes and it can be done over the phone. Our credit card processor will call you to give step-by-step instructions.</div>
                      

                      <h4 class="accordion-toggle"><span>What if I am not happy with Dan Advance Funding’s affiliated credit card processor?</span></h4>
                      <div class="accordion-content">We will try to resolve any issues right away for you. If not, we will switch you to one of our other processors. But staying with one of our processors is mandatory</div>
                      </li>


                  </div>

                </div>


              </div>
          </div>
        </div>
      </div>
    </section>





  </main>
</template>
<script>

import RwvSubscribe from '@/components/Subscribe'
export default{
  name: 'Home',
  components: {
    RwvSubscribe
  },
  data: function() {
    return {
      banner:require('./../../static/images/faq.jpg')
    }
  },
  mounted() {

        

  }
}

</script>


// WEBPACK FOOTER //
// src/views/Faq.vue